const Config = {
    "APP_BASE_URL": window._env_.web.APP_BASE_URL,
    "BASE_URL": window._env_.web.BASE_URL,
    "STRIPE_PUBLISHABLE_KEY": window._env_.web.STRIPE_PUBLISHABLE_KEY,
    "GOOGLE_LOGIN_CLIENT_ID": window._env_.web.GOOGLE_LOGIN_CLIENT_ID,
    "APPLE_LOGIN_CLIENT_ID": window._env_.web.APPLE_LOGIN_CLIENT_ID,
    "CAPTCHA_SITE_KEY": window._env_.web.CAPTCHA_SITE_KEY,
    "CLASSIC_VIEW_DOMAIN": window._env_.web.CLASSIC_VIEW_DOMAIN,
    "ENV": window._env_.web.ENV,
    "ENABLE_CHAT": window._env_.web.ENABLE_CHAT,
    "BUILD_VERSION": window._env_.web.BUILD_VERSION,
    "GA_KEY": window._env_.web.GA_KEY,
}

export default Config;